"use client";

import { CcSeoProcess } from "@/components/services/seo/CcSeoProcess";
import type { SeoPageCopy } from "@/components/services/seo/seo-page-copy";

import { WEB_PROCESS_ILLUSTRATIONS } from "./web-process-illustrations";

/**
 * The process section with the webbyrå drawings. A client wrapper, because
 * drawing components can't be passed as props from the server view.
 */
export function CcWebProcess({ copy }: { copy: SeoPageCopy["process"] }) {
  return <CcSeoProcess copy={copy} illustrations={WEB_PROCESS_ILLUSTRATIONS} />;
}
